import { render, staticRenderFns } from "./RatingView.vue?vue&type=template&id=a8071cac&scoped=true&"
import script from "./RatingView.vue?vue&type=script&lang=js&"
export * from "./RatingView.vue?vue&type=script&lang=js&"
import style0 from "./RatingView.vue?vue&type=style&index=0&id=a8071cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8071cac",
  null
  
)

export default component.exports